import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-toastify';
import { updateWebhookRegistrationQuery } from '../apis';

const useUpdateWebhookRegistration = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: updateWebhookRegistrationQuery,
    onSuccess: () => {
      toast.success('Webhook registration updated successfully');
      queryClient.invalidateQueries({ queryKey: ['webhook-registration', 'list'] });
      queryClient.invalidateQueries({ queryKey: ['webhook-registration', 'detail'] });
    },
    onError: (error) => {
      const message = error?.response?.data?.message ?? 'Failed to update webhook registration';
      toast.error(message);
    },
  });
};

export default useUpdateWebhookRegistration;
